"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModal = void 0;
var useBooleanToggle_1 = require("./useBooleanToggle");
function useModal(startsOpen) {
    if (startsOpen === void 0) { startsOpen = false; }
    var _a = __read((0, useBooleanToggle_1.useBooleanToggle)(startsOpen), 2), visible = _a[0], toggle = _a[1];
    return {
        visible: visible,
        toggle: toggle,
    };
}
exports.useModal = useModal;
